import {
  ExtraOptions,
  RouterModule,
  Routes,
  PreloadAllModules
} from "@angular/router";
import { NgModule } from "@angular/core";
import { AppPreloadingStrategy } from "./@core/CustomPreloadingStrategy";

const routes: Routes = [
  {
    path: 'public-liability',
    loadChildren: () =>
      import('./pages/pages.module').then(
        (m) => m.PagesModule
      ),
    data: {
      preload: true,
      delay: false
    }
  },
  {
    path: 'user-area',
    loadChildren: () =>
      import('./user-area/user-area.module').then(
        (m) => m.UserAreaModule
      ),
    data: {
      preload: false,
      delay: false
    }
  },
  {
    path: 'recall',
    loadChildren: () =>
      import('./recall/recall.module').then(
        (m) => m.RecallModule
      ),
    data: {
      preload: true,
      delay: true
    }
  },
  {
    path: 'session-expired',
    loadChildren: () =>
      import('./@theme/components/error-pages/session-expired/session-expired.module').then(
        (m) => m.SessionExpiredModule
      ),
    data: {
      preload: false,
      delay: false
    }
  },
  {
    path: 'error-page',
    loadChildren: () =>
      import('./@theme/components/error-pages/error-page/error-page.module').then(
        (m) => m.ErrorPageModule
      ),
    data: {
      preload: false,
      delay: false
    }
  },
  {
    path: 'post-quote-decline',
    loadChildren: () =>
      import('./@theme/components/error-pages/post-quote-decline/post-quote-decline.module').then(
        (m) => m.PostQuoteDeclineModule
      ),
    data: {
      preload: true,
      delay: true
    }
  },
  {
    path: 'session-wrong',
    loadChildren: () =>
      import('./@theme/components/error-pages/session-wrong/session-wrong.module').then(
        (m) => m.SessionWrongModule
      ),
    data: {
      preload: true,
      delay: true
    }
  },
  {
    path: 'unable-to-quote',
    loadChildren: () =>
      import('./@theme/components/error-pages/unable-quote/unable-quote.module').then(
        (m) => m.UnableQuoteModule
      ),
    data: {
      preload: true,
      delay: true
    }
  },
  { path: "", redirectTo: "public-liability", pathMatch: "full" },
  { path: "**", redirectTo: "public-liability" }
];

const config: ExtraOptions = {
  useHash: true
};

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: AppPreloadingStrategy // <-This is our preloading
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
